import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserById, getDocuments, getProfilePicture } from './../actions/user-api';
import { GetPartnerById, GetEtablissementById, GetEtablissementsByPartnerId, GetUsersByPartnerIdAndEtablissementIdDefaultAnticipa, GetUsersByPartnerIdAndEtablissementIdDefaultFacilita, GetUsersByPartnerIdAndEtablissementIdDefaultSerenita } from './../actions/partner/partner';
import * as R from 'ramda';
import JwtDecode from 'jwt-decode';
import * as axios from 'axios';
import { ToastContainer } from 'react-toastify';
import history from './../utils/history';

// Partner
// ==========================================
// Partner: Common
import { Navbar } from './_common/navbar';
import { AjouterDossier } from './_common/ajouterDossier/index';

// Partner: Views
import { Dashboard } from './dashboard';
import { Facilita } from './facilita';
import {Serenita} from './serenita'
import { Anticipa } from './anticipa';
import { Settings } from './settings';
import { Payment } from './paiement';
import { getUserRepresentatives } from '../actions/backoffice/partners';
import { FileTypes } from '../constants/utils/fileTypes';

export const Partner = () => {
	const searchQuery = useLocation();
	const router = useSelector(state => state.router);
	const dispatch = useDispatch();
	const userReducer = useSelector(state => state.user);
	const partnerReducer = useSelector(state => state.partnerReducer);
	const [hasLoadedInit, setHasLoadedInit] = useState(false);
	const [anticipaUsers, setAnticipaUsers] = useState(undefined);
	const [facilitaUsers, setFacilitaUsers] = useState(undefined);
	const [serenitaUsers, setSerenitaUsers] = useState(undefined);
	const [isPartner, setIsPartner] = useState(false);
	const [showSerenita, setShowSerenita] = useState(false);

	const pageQuery = new URLSearchParams(searchQuery.search);
	let page = pageQuery.get('page');

	useEffect(() => {
		var accessToken = sessionStorage.getItem("access_token");


		if (!R.isNil(accessToken)) {
			axios.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
			var decoded = JwtDecode(accessToken);
			if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
				dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
			}
			if (!R.isNil(decoded) && !R.isNil(decoded["PartnerId"])) {
				dispatch(GetPartnerById(decoded["PartnerId"])).then(() => {
					if (R.isNil(decoded["EtablissementId"])) {
						dispatch(GetEtablissementsByPartnerId(decoded["PartnerId"]))
						.then(() => setHasLoadedInit(true));
					}
				});
				if (!R.isNil(decoded["EtablissementId"])) {
					dispatch(GetEtablissementById(decoded["PartnerId"], decoded["EtablissementId"])).then(() => {
						setHasLoadedInit(true);
					});
				}

				let rolesFromToken = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
				let roles = Array.isArray(rolesFromToken) ? rolesFromToken : [rolesFromToken];
				setIsPartner(roles.includes("PARTNER"));
			}
		} else {
			history.push("/auth/partner/signin");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (hasLoadedInit && !R.isNil(partnerReducer.partner)) {
			//page, pageSearch, status, startDate, endDate, sortBy, sortDesc
			dispatch(GetUsersByPartnerIdAndEtablissementIdDefaultAnticipa(partnerReducer.partner.id, !R.isNil(partnerReducer.etablissement) ? partnerReducer.etablissement.id : null, "anticipa", 50));
			dispatch(GetUsersByPartnerIdAndEtablissementIdDefaultFacilita(partnerReducer.partner.id, !R.isNil(partnerReducer.etablissement) ? partnerReducer.etablissement.id : null, "facilita", 50));
			if(
				(!R.isNil(partnerReducer.etablissement) && partnerReducer.etablissement.isSerenita) ||
				!R.isNil(partnerReducer.etablissementList.items.find(item => item.isSerenita))
			){
				setShowSerenita(true);
				dispatch(GetUsersByPartnerIdAndEtablissementIdDefaultSerenita(partnerReducer.partner.id, !R.isNil(partnerReducer.etablissement) ? partnerReducer.etablissement.id : null, "serenita", 50));	
			}
		}

	}, [hasLoadedInit, partnerReducer.partner, partnerReducer.etablissement, partnerReducer.etablissementList.items]);

	useEffect(() => {
		if (!R.isNil(userReducer.user)) {
			dispatch(getDocuments(userReducer.user));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userReducer.user]);

	useEffect(() => {
		const profilePicture = userReducer.documents.find(d => d.fileType === FileTypes.ProfilePicture);
		if (!R.isNil(profilePicture))
			dispatch(getProfilePicture(userReducer.user.id, profilePicture.fileName));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userReducer.documents]);

	useEffect(() => {

		// fetch all representatives by user id
		async function getAllDossiers(anticipa, facilita, serenita) {

			const userPromises = [];

			const dossiers = anticipa.concat(facilita, serenita);
			dossiers.forEach(user => {
				userPromises.push(getUserRepresentatives(user.id));
			});

			let representatives = await Promise.all(userPromises);
			representatives = representatives.filter(u => !R.isEmpty(u)).map(userRepresent => userRepresent.filter(r => r.isMainRepresentative)[0]);

			let users = dossiers.map(u => {
				let representative = representatives.find(r => r.userId === u.id);
				if (!R.isNil(representative)) {

					u.mainRepresentative = {
						id: representative.id,
						firstName: representative.firstName,
						lastName: representative.lastName
					};

				}
				return u;
			});
			const usersAnticipa = users.filter(u => !u.createdByRepresentative)
			setAnticipaUsers(usersAnticipa);

			const usersFacilita = users.filter(u => u.createdByRepresentative && !u.isSerenita)
			setFacilitaUsers(usersFacilita);

			const usersSerenita = users.filter(u => u.createdByRepresentative && u.isSerenita)
			setSerenitaUsers(usersSerenita);

		};
		if (!R.isNil(partnerReducer.allDossiers.anticipa) || !R.isNil(partnerReducer.allDossiers.facilita) || !R.isNil(partnerReducer.allDossiers.serenita)) {
			getAllDossiers(
				!R.isNil(partnerReducer.allDossiers.anticipa) ? partnerReducer.allDossiers.anticipa : [], 
				!R.isNil(partnerReducer.allDossiers.facilita) ? partnerReducer.allDossiers.facilita : [], 
				!R.isNil(partnerReducer.allDossiers.serenita) ? partnerReducer.allDossiers.serenita : []);
		}


	}, [partnerReducer.allDossiers]);



	if (R.isNil(partnerReducer.partner))
		return '';
	// if (R.isNil(partnerReducer.etablissement))
	// 	return '';

	if (R.isNil(userReducer.user))
		return '';

	if (R.isNil(partnerReducer.allDossiers.anticipa) || R.isNil(partnerReducer.allDossiers.facilita))
		return '';

	if (R.isNil(facilitaUsers) || R.isNil(anticipaUsers)){
		return '';
	}


	return (
		<React.Fragment>
			<ToastContainer />
			<div className={"layout layout-row" + (!R.isNil(partnerReducer.partner.color) && partnerReducer.partner.color !== "" ? "" : " bg-gradient-secondary")} style={{ backgroundColor: "#" + partnerReducer.partner.color }}>
				<h1 className="sr-only visually-hidden">Assist@</h1>
				<Navbar location={router.location} userInfo={userReducer} user={userReducer.user} partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} profilePicture={userReducer.profilePicture} isPartner={isPartner} showSerenita={showSerenita} />
				<main role="main" className="view flex-grow-1 bg-gradient-light">
					<h1 className="sr-only visually-hidden">Assist@: Main</h1>
					<Switch>
						<Route path="/partner/create-dossier">
							<AjouterDossier partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} />
						</Route>
						<Route path="/partner/dashboard">
							<Dashboard partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} isPartner={isPartner} partnerstate={partnerReducer} anticipaUsersRepresentative={anticipaUsers} facilitaUsersRepresentative={facilitaUsers} serenitaUsersRepresentative={serenitaUsers} />
						</Route>
						<Route path="/partner/anticipa">
							<Anticipa partnerState={partnerReducer} partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} isPartner={isPartner} />
						</Route>
						<Route path="/partner/facilita">
							<Facilita partnerState={partnerReducer} partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} isPartner={isPartner} />
						</Route>
						<Route path="/partner/serenita">
							<Serenita partnerState={partnerReducer} partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} isPartner={isPartner} />
						</Route>
						<Route path="/partner/paiement">
							<Payment partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} />
						</Route>
						<Route path="/partner/settings">
							<Settings user={userReducer.user} isLoading={userReducer.isLoading} />
						</Route>

						<Route render={() => {
							return <Redirect exact to="/partner/dashboard" />;
						}} />
					</Switch>
				</main>
			</div>
		</React.Fragment>
	);
};